import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { DealsComponent } from '../../../../../pages/datasets/deals/deals.component';

export const deals: Route = {
  path: 'deals',
  title: 'nav.datasets.deals',
  data: {
    icon: SbIcons.budgetCoin,
    breadcrumb: 'nav.datasets.deals',
    id: RoutingID.deals,
  },
  children: [
    {
      path: '',
      component: DealsComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
